import { useRoute } from 'vue-router'
import message from "@/components/common/message/Message.vue";
export default {
    name: 'ObjectPaid',

    components: {
        message
    },

    data() {
        return {
            loading: false,
            success: null,
            seconds: 5,
            timer: null,
            message: null,
            isVisibleMsg: false,
            isMsg: null
        }
    },

    methods: {
        async populateData() {
            this.loading = true;
            try {
                const route = useRoute();
                const { data } = await this.getObjectPaid(route.params.token);
                if (data) {
                    this.timer = setInterval(() => {
                        this.seconds--
                        if (this.seconds === 0) {
                            clearInterval(this.timer)
                            this.$router.push('/object/monitoring')
                        }
                    }, 1000);
                    if (data.success) {
                        this.success = data.success;
                    } else if (data.error) {
                        this.message = data.error;
                        this.isMsg = 'danger';
                        this.isVisibleMsg = true;
                    }
                }
            } finally {
                this.loading = false;
            }
        },

        async getObjectPaid(token) {
            return this.ApiRequest.requestAsync(
                `stripe/object/paid/${token}`,
                this.ApiRequest.REQUEST_GET,
                [],
                'stripe-paid-object',
                false
            );
        },

        changeIsVisibleMsg(isVisible) {
            this.isVisibleMsg = isVisible;
        },
    },

    beforeUnmount() {
        clearInterval(this.timer)
    },

    beforeMount() {
        this.populateData();
    },
}
